export function typedKeys<T extends string>(obj: Record<T, unknown>): T[] {
  return Object.keys(obj) as T[];
}
